"use client";

import { usePathname } from "next/navigation";
import { defaultLocale, isValidLocale, type Locale } from "@/lib/i18n";

/**
 * Extract the current locale from the URL pathname.
 */
export function useLocale(): Locale {
  const pathname = usePathname();
  const segment = pathname.split("/")[1]; // e.g. "tw" or "en"
  return isValidLocale(segment) ? segment : defaultLocale;
}

/**
 * Prefix a path with the current locale.
 * Only prefixes internal paths (starting with /).
 */
export function useLocalePath() {
  const locale = useLocale();
  return (path: string) => {
    if (!path.startsWith("/")) return path; // external or relative
    return `/${locale}${path}`;
  };
}
